export enum Lang {
  de = "de",
  en = "en",
  cz = "cz",
  pl = "pl",
}
